import React, { useEffect, useState } from 'react';
import {
  Box,
  IconButton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import clsx from 'clsx';
import { useNavigate, useParams } from 'react-router-dom';
import { apiClient } from 'shared/api';
import { useUser } from 'shared/api/tanstack';
import ArrowRight from 'shared/assets/icons/arrow_right.svg';
import { DashboardHeaderBackLink } from 'widgets/dashboard-header-back-link/';
import styles from './all-applications.module.scss';

export const AllApplications = () => {
  const navigate = useNavigate();
  const { type } = useParams();

  const { data: user } = useUser();

  function GoToApp(type?: string, appId?: string) {
    if (type === 'select') {
      const app: any = allApp.find((app: any) => app.documentId === appId);
      if (!app) return;
      if (user.user_type === 'supplier' || user.user_type === 'leasing') {
        const offer = app?.select_offers.find((offer: any) => offer.name === user.username);
        if (!offer) return;
        navigate(`/app/select/${app.custom_uid}/${offer.custom_uid}`);
      } else {
        navigate(`/dashboard/app/select/${app.id}`);
      }
    } else if (type === 'leasing') {
      const app: any = allApp.find((app: any) => app.documentId === appId);
      if (!app) return;
      if (user.user_type === 'leasing') {
        const offer = app?.leasing_offers.find((offer: any) => offer.name === user.username);
        if (!offer) return;
        navigate(`/app/leasing/${app.custom_uid}/${offer.custom_uid}`);
      } else {
        navigate(`/dashboard/app/leasing/${app.id}`);
      }
    }
  }

  const title = type == 'select' ? 'Подбор транспортного средства' : 'Лизинг';
  const headerTitlePriceText =
    type == 'select' ? 'Бюджет на покупку' : 'Стоимость предмета лизинга';

  const url = type == 'select' ? '/select-applications/all' : '/leasing-applications/all';

  const getAllApp = async () => {
    try {
      const response = await apiClient.get(url);
      const data = response?.data?.data
        ? response.data.data.filter((item: any) => item.fulfilled !== false)
        : [];
      setAllApp(data);
    } catch (error) {
      console.error('Ошибка при получении данных: ', error);
    }
  };

  const [allApp, setAllApp] = useState([]);

  useEffect(() => {
    getAllApp();
  }, []);

  const isNew = (status: string) => {
    return status == 'Новая';
  };
  const isProcessing = (status: string) => {
    return status == 'В обработке';
  };
  const isProcessed = (status: string) => {
    return status == 'Обработана';
  };
  const isConfirmation = (status: string) => {
    return status == 'Ожидает подтвержд.';
  };
  const isConfirmed = (status: string) => {
    return status == 'На оформлении';
  };
  const isCompleted = (status: string) => {
    return status == 'Выполнена';
  };
  const isClosed = (status: string) => {
    return status == 'Закрыта';
  };
  const isCanceled = (status: string) => {
    return status == 'Отменена';
  };

  const getStatusApp = (status: string) => {
    if (status == 'Ожидает подтвержд.') {
      return 'На одобрении';
    }
    return status;
  };

  const renderHeaderRow = () => {
    return (
      <TableRow className={styles.tableHeadRow}>
        <TableCell className={`${styles.tableHeadCellFirst} ${styles.tableHeadCell}`}>
          № заявки
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableCellSmall}`} align='left'>
          Транспортное средство
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableCellMobile}`} align='left'>
          Марка
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableCellMobile}`} align='left'>
          Модель
        </TableCell>
        {type === 'leasing' && (
          <TableCell className={`${styles.tableHeadCell} ${styles.tableCellSmall}`} align='left'>
            {headerTitlePriceText}
          </TableCell>
        )}
        <TableCell className={styles.tableHeadCell} align='left'>
          Статус заявки
        </TableCell>
        <TableCell
          className={`${styles.tableHeadCellLast} ${styles.tableHeadCell}`}
          align='right'
        />
      </TableRow>
    );
  };

  const renderRows = (rows: any) => {
    return rows.map((row: any) => (
      <TableRow
        className={styles.tableBodyRow}
        key={row.id}
        sx={{ '& td, & th': { border: 0 }, marginTop: '10px' }}
      >
        <TableCell
          className={`${styles.tableBodyCellFirst} ${styles.tableBodyCell}`}
          component='th'
          scope='row'
        >
          {row.id}
        </TableCell>
        <TableCell className={`${styles.tableBodyCell} ${styles.tableCellSmall}`} align='left'>
          {row.car_type}/{row.car_subtype}
        </TableCell>
        <TableCell className={`${styles.tableBodyCell} ${styles.tableCellMobile}`} align='left'>
          {row.car_brand}
        </TableCell>
        <TableCell className={`${styles.tableBodyCell} ${styles.tableCellMobile}`} align='left'>
          {row.vehicle}
        </TableCell>
        {type === 'leasing' && (
          <TableCell className={`${styles.tableBodyCell} ${styles.tableCellSmall}`} align='left'>
            {new Intl.NumberFormat('ru-RU').format(row.price as number)} ₽
          </TableCell>
        )}
        <TableCell
          className={clsx([
            `${styles.tableBodyCell}`,
            isNew(row.status_app) && `${styles.statusNew}`,
            isProcessing(row.status_app) && `${styles.statusProcessing}`,
            isProcessed(row.status_app) && `${styles.statusProcessed}`,
            isConfirmation(row.status_app) && `${styles.statusConfirmation}`,
            isConfirmed(row.status_app) && `${styles.statusConfirmed}`,
            isCompleted(row.status_app) && `${styles.statusCompleted}`,
            isClosed(row.status_app) && `${styles.statusClosed}`,
            isCanceled(row.status_app) && `${styles.statusCanceled}`,
          ])}
          align='left'
        >
          {getStatusApp(row.status_app)}
        </TableCell>
        <TableCell className={`${styles.tableBodyCellLast} ${styles.tableBodyCell}`} align='right'>
          <IconButton
            disableRipple
            sx={{
              width: '40px',
              height: '40px',
            }}
            onClick={() => GoToApp(type, row.documentId)}
            edge='end'
            className={styles.svgIcon}
          >
            <SvgIcon component={ArrowRight} inheritViewBox sx={{ fontSize: '18px' }} />
          </IconButton>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <Box className={styles.allPage}>
      <DashboardHeaderBackLink link={'/dashboard/last'} title={title} />
      <Box>
        <TableContainer component={Box} className={styles.tableContainer}>
          <Table className={styles.table} sx={{ minWidth: 1070 }} aria-label={title}>
            <TableHead className={styles.tableHead}>{renderHeaderRow()}</TableHead>
            <TableBody className={styles.tableBody}>{renderRows(allApp)}</TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};
